/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SubdomainIndexRouteImport } from './routes/subdomain/index'
import { Route as SubdomainAdminRouteRouteImport } from './routes/subdomain/admin/route'
import { Route as SubdomainAppRouteRouteImport } from './routes/subdomain/app/route'
import { Route as SubdomainAdminAuthRouteRouteImport } from './routes/subdomain/admin/_auth/route'
import { Route as SubdomainAdminStaffRouteRouteImport } from './routes/subdomain/admin/_staff/route'
import { Route as SubdomainAppAuthRouteRouteImport } from './routes/subdomain/app/_auth/route'
import { Route as SubdomainAppClientRouteRouteImport } from './routes/subdomain/app/_client/route'
import { Route as SubdomainAppAuditRouteImport } from './routes/subdomain/app/audit'
import { Route as SubdomainDevIndexRouteImport } from './routes/subdomain/dev/index'
import { Route as SubdomainDevGraphRouteImport } from './routes/subdomain/dev/graph'
import { Route as SubdomainAdminAuthAdminLoginRouteImport } from './routes/subdomain/admin/_auth/admin-login'
import { Route as SubdomainAdminAuthForgotPasswordRouteImport } from './routes/subdomain/admin/_auth/forgot-password'
import { Route as SubdomainAdminAuthInviteRouteImport } from './routes/subdomain/admin/_auth/invite'
import { Route as SubdomainAdminAuthTwoFactorRouteImport } from './routes/subdomain/admin/_auth/two-factor'
import { Route as SubdomainAdminStaffIndexRouteImport } from './routes/subdomain/admin/_staff/index'
import { Route as SubdomainAdminStaffSettingsRouteRouteImport } from './routes/subdomain/admin/_staff/settings/route'
import { Route as SubdomainAppAuthForgotPasswordRouteImport } from './routes/subdomain/app/_auth/forgot-password'
import { Route as SubdomainAppAuthTwoFactorRouteImport } from './routes/subdomain/app/_auth/two-factor'
import { Route as SubdomainAppAuthVerifyEmailRouteImport } from './routes/subdomain/app/_auth/verify-email'
import { Route as SubdomainAppAuthWelcomeRouteImport } from './routes/subdomain/app/_auth/welcome'
import { Route as SubdomainAppClientIndexRouteImport } from './routes/subdomain/app/_client/index'
import { Route as SubdomainAppClientSettingsRouteRouteImport } from './routes/subdomain/app/_client/settings/route'
import { Route as SubdomainAdminStaffBusinessesIndexRouteImport } from './routes/subdomain/admin/_staff/businesses/index'
import { Route as SubdomainAdminStaffSettingsIndexRouteImport } from './routes/subdomain/admin/_staff/settings/index'
import { Route as SubdomainAdminStaffSettingsAvailabilityRouteImport } from './routes/subdomain/admin/_staff/settings/availability'
import { Route as SubdomainAdminStaffSettingsConnectionsRouteImport } from './routes/subdomain/admin/_staff/settings/connections'
import { Route as SubdomainAdminStaffSettingsNotificationsRouteImport } from './routes/subdomain/admin/_staff/settings/notifications'
import { Route as SubdomainAdminStaffSettingsProfileRouteImport } from './routes/subdomain/admin/_staff/settings/profile'
import { Route as SubdomainAdminStaffSettingsSecurityRouteImport } from './routes/subdomain/admin/_staff/settings/security'
import { Route as SubdomainAdminStaffSettingsWorkspaceRouteRouteImport } from './routes/subdomain/admin/_staff/settings/workspace/route'
import { Route as SubdomainAdminStaffStaffIndexRouteImport } from './routes/subdomain/admin/_staff/staff/index'
import { Route as SubdomainAdminStaffStaffStaffIdRouteImport } from './routes/subdomain/admin/_staff/staff/$staffId'
import { Route as SubdomainAppAuthOnboardingBusinessRouteImport } from './routes/subdomain/app/_auth/onboarding/business'
import { Route as SubdomainAppAuthOnboardingIndustryRouteImport } from './routes/subdomain/app/_auth/onboarding/industry'
import { Route as SubdomainAppAuthOnboardingPhoneRouteImport } from './routes/subdomain/app/_auth/onboarding/phone'
import { Route as SubdomainAppAuthOnboardingSocialsRouteImport } from './routes/subdomain/app/_auth/onboarding/socials'
import { Route as SubdomainAppAuthOnboardingWebsiteRouteImport } from './routes/subdomain/app/_auth/onboarding/website'
import { Route as SubdomainAppAuthSignInIndexRouteImport } from './routes/subdomain/app/_auth/sign-in/index'
import { Route as SubdomainAppAuthSignInEmailRouteImport } from './routes/subdomain/app/_auth/sign-in/email'
import { Route as SubdomainAppAuthSignUpIndexRouteImport } from './routes/subdomain/app/_auth/sign-up/index'
import { Route as SubdomainAppAuthSignUpEmailRouteImport } from './routes/subdomain/app/_auth/sign-up/email'
import { Route as SubdomainAppClientProjectsIndexRouteImport } from './routes/subdomain/app/_client/projects/index'
import { Route as SubdomainAppClientProjectsProjectIdRouteImport } from './routes/subdomain/app/_client/projects/$projectId'
import { Route as SubdomainAppClientProjectsDeliverablesRouteImport } from './routes/subdomain/app/_client/projects/deliverables'
import { Route as SubdomainAppClientSettingsNotificationsRouteImport } from './routes/subdomain/app/_client/settings/notifications'
import { Route as SubdomainAppClientSettingsProfileRouteImport } from './routes/subdomain/app/_client/settings/profile'
import { Route as SubdomainAppClientSettingsSecurityRouteImport } from './routes/subdomain/app/_client/settings/security'
import { Route as SubdomainAppClientTasksTaskIdRouteImport } from './routes/subdomain/app/_client/tasks/$taskId'
import { Route as SubdomainAdminStaffBusinessesBusinessIdIndexRouteImport } from './routes/subdomain/admin/_staff/businesses/$businessId/index'
import { Route as SubdomainAdminStaffBusinessesBusinessIdDeliverablesRouteImport } from './routes/subdomain/admin/_staff/businesses/$businessId/deliverables'
import { Route as SubdomainAdminStaffBusinessesBusinessIdProjectsRouteImport } from './routes/subdomain/admin/_staff/businesses/$businessId/projects'
import { Route as SubdomainAdminStaffProjectsProjectIdIndexRouteImport } from './routes/subdomain/admin/_staff/projects/$projectId/index'
import { Route as SubdomainAdminStaffSettingsWorkspaceAgencyRouteImport } from './routes/subdomain/admin/_staff/settings/workspace/agency'
import { Route as SubdomainAdminStaffSettingsWorkspaceFlagsRouteImport } from './routes/subdomain/admin/_staff/settings/workspace/flags'
import { Route as SubdomainAdminStaffSettingsWorkspaceIntegrationsRouteImport } from './routes/subdomain/admin/_staff/settings/workspace/integrations'
import { Route as SubdomainAdminStaffSettingsWorkspaceLimitsRouteImport } from './routes/subdomain/admin/_staff/settings/workspace/limits'
import { Route as SubdomainAdminStaffSettingsWorkspaceMaintenanceRouteImport } from './routes/subdomain/admin/_staff/settings/workspace/maintenance'
import { Route as SubdomainAdminStaffSettingsWorkspaceRolesRouteImport } from './routes/subdomain/admin/_staff/settings/workspace/roles'
import { Route as SubdomainAdminStaffSettingsWorkspaceSchedulingRouteImport } from './routes/subdomain/admin/_staff/settings/workspace/scheduling'
import { Route as SubdomainAdminStaffSettingsWorkspaceSecurityPolicyRouteImport } from './routes/subdomain/admin/_staff/settings/workspace/security-policy'
import { Route as SubdomainAdminStaffSettingsWorkspaceStaffSecurityRouteImport } from './routes/subdomain/admin/_staff/settings/workspace/staff-security'
import { Route as SubdomainAdminStaffSettingsWorkspaceTeamNotificationsRouteImport } from './routes/subdomain/admin/_staff/settings/workspace/team-notifications'
import { Route as SubdomainAdminStaffTasksTaskIdIndexRouteImport } from './routes/subdomain/admin/_staff/tasks/$taskId/index'
import { Route as SubdomainAdminStaffTasksTaskIdEditRouteImport } from './routes/subdomain/admin/_staff/tasks/$taskId/edit'
import { Route as SubdomainAdminStaffTasksTaskIdSubmitRouteImport } from './routes/subdomain/admin/_staff/tasks/$taskId/submit'
import { Route as SubdomainAdminStaffWorkbenchReviewsIndexRouteImport } from './routes/subdomain/admin/_staff/workbench/reviews/index'
import { Route as SubdomainAdminStaffWorkbenchReviewsTaskIdRouteImport } from './routes/subdomain/admin/_staff/workbench/reviews/$taskId'
import { Route as SubdomainAppClientWorkReviewTaskIdRouteImport } from './routes/subdomain/app/_client/work/review/$taskId'
import { Route as SubdomainAdminStaffProjectsProjectIdTasksNewRouteImport } from './routes/subdomain/admin/_staff/projects/$projectId/tasks/new'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SubdomainIndexRoute = SubdomainIndexRouteImport.update({
  id: '/subdomain/',
  path: '/subdomain/',
  getParentRoute: () => rootRouteImport,
} as any)
const SubdomainAdminRouteRoute = SubdomainAdminRouteRouteImport.update({
  id: '/subdomain/admin',
  path: '/subdomain/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const SubdomainAppRouteRoute = SubdomainAppRouteRouteImport.update({
  id: '/subdomain/app',
  path: '/subdomain/app',
  getParentRoute: () => rootRouteImport,
} as any)
const SubdomainAdminAuthRouteRoute = SubdomainAdminAuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => SubdomainAdminRouteRoute,
} as any)
const SubdomainAdminStaffRouteRoute =
  SubdomainAdminStaffRouteRouteImport.update({
    id: '/_staff',
    getParentRoute: () => SubdomainAdminRouteRoute,
  } as any)
const SubdomainAppAuthRouteRoute = SubdomainAppAuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => SubdomainAppRouteRoute,
} as any)
const SubdomainAppClientRouteRoute = SubdomainAppClientRouteRouteImport.update({
  id: '/_client',
  getParentRoute: () => SubdomainAppRouteRoute,
} as any)
const SubdomainAppAuditRoute = SubdomainAppAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => SubdomainAppRouteRoute,
} as any)
const SubdomainDevIndexRoute = SubdomainDevIndexRouteImport.update({
  id: '/subdomain/dev/',
  path: '/subdomain/dev/',
  getParentRoute: () => rootRouteImport,
} as any)
const SubdomainDevGraphRoute = SubdomainDevGraphRouteImport.update({
  id: '/subdomain/dev/graph',
  path: '/subdomain/dev/graph',
  getParentRoute: () => rootRouteImport,
} as any)
const SubdomainAdminAuthAdminLoginRoute =
  SubdomainAdminAuthAdminLoginRouteImport.update({
    id: '/admin-login',
    path: '/admin-login',
    getParentRoute: () => SubdomainAdminAuthRouteRoute,
  } as any)
const SubdomainAdminAuthForgotPasswordRoute =
  SubdomainAdminAuthForgotPasswordRouteImport.update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => SubdomainAdminAuthRouteRoute,
  } as any)
const SubdomainAdminAuthInviteRoute =
  SubdomainAdminAuthInviteRouteImport.update({
    id: '/invite',
    path: '/invite',
    getParentRoute: () => SubdomainAdminAuthRouteRoute,
  } as any)
const SubdomainAdminAuthTwoFactorRoute =
  SubdomainAdminAuthTwoFactorRouteImport.update({
    id: '/two-factor',
    path: '/two-factor',
    getParentRoute: () => SubdomainAdminAuthRouteRoute,
  } as any)
const SubdomainAdminStaffIndexRoute =
  SubdomainAdminStaffIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SubdomainAdminStaffRouteRoute,
  } as any)
const SubdomainAdminStaffSettingsRouteRoute =
  SubdomainAdminStaffSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => SubdomainAdminStaffRouteRoute,
  } as any)
const SubdomainAppAuthForgotPasswordRoute =
  SubdomainAppAuthForgotPasswordRouteImport.update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => SubdomainAppAuthRouteRoute,
  } as any)
const SubdomainAppAuthTwoFactorRoute =
  SubdomainAppAuthTwoFactorRouteImport.update({
    id: '/two-factor',
    path: '/two-factor',
    getParentRoute: () => SubdomainAppAuthRouteRoute,
  } as any)
const SubdomainAppAuthVerifyEmailRoute =
  SubdomainAppAuthVerifyEmailRouteImport.update({
    id: '/verify-email',
    path: '/verify-email',
    getParentRoute: () => SubdomainAppAuthRouteRoute,
  } as any)
const SubdomainAppAuthWelcomeRoute = SubdomainAppAuthWelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => SubdomainAppAuthRouteRoute,
} as any)
const SubdomainAppClientIndexRoute = SubdomainAppClientIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SubdomainAppClientRouteRoute,
} as any)
const SubdomainAppClientSettingsRouteRoute =
  SubdomainAppClientSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => SubdomainAppClientRouteRoute,
  } as any)
const SubdomainAdminStaffBusinessesIndexRoute =
  SubdomainAdminStaffBusinessesIndexRouteImport.update({
    id: '/businesses/',
    path: '/businesses/',
    getParentRoute: () => SubdomainAdminStaffRouteRoute,
  } as any)
const SubdomainAdminStaffSettingsIndexRoute =
  SubdomainAdminStaffSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SubdomainAdminStaffSettingsRouteRoute,
  } as any)
const SubdomainAdminStaffSettingsAvailabilityRoute =
  SubdomainAdminStaffSettingsAvailabilityRouteImport.update({
    id: '/availability',
    path: '/availability',
    getParentRoute: () => SubdomainAdminStaffSettingsRouteRoute,
  } as any)
const SubdomainAdminStaffSettingsConnectionsRoute =
  SubdomainAdminStaffSettingsConnectionsRouteImport.update({
    id: '/connections',
    path: '/connections',
    getParentRoute: () => SubdomainAdminStaffSettingsRouteRoute,
  } as any)
const SubdomainAdminStaffSettingsNotificationsRoute =
  SubdomainAdminStaffSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => SubdomainAdminStaffSettingsRouteRoute,
  } as any)
const SubdomainAdminStaffSettingsProfileRoute =
  SubdomainAdminStaffSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => SubdomainAdminStaffSettingsRouteRoute,
  } as any)
const SubdomainAdminStaffSettingsSecurityRoute =
  SubdomainAdminStaffSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => SubdomainAdminStaffSettingsRouteRoute,
  } as any)
const SubdomainAdminStaffSettingsWorkspaceRouteRoute =
  SubdomainAdminStaffSettingsWorkspaceRouteRouteImport.update({
    id: '/workspace',
    path: '/workspace',
    getParentRoute: () => SubdomainAdminStaffSettingsRouteRoute,
  } as any)
const SubdomainAdminStaffStaffIndexRoute =
  SubdomainAdminStaffStaffIndexRouteImport.update({
    id: '/staff/',
    path: '/staff/',
    getParentRoute: () => SubdomainAdminStaffRouteRoute,
  } as any)
const SubdomainAdminStaffStaffStaffIdRoute =
  SubdomainAdminStaffStaffStaffIdRouteImport.update({
    id: '/staff/$staffId',
    path: '/staff/$staffId',
    getParentRoute: () => SubdomainAdminStaffRouteRoute,
  } as any)
const SubdomainAppAuthOnboardingBusinessRoute =
  SubdomainAppAuthOnboardingBusinessRouteImport.update({
    id: '/onboarding/business',
    path: '/onboarding/business',
    getParentRoute: () => SubdomainAppAuthRouteRoute,
  } as any)
const SubdomainAppAuthOnboardingIndustryRoute =
  SubdomainAppAuthOnboardingIndustryRouteImport.update({
    id: '/onboarding/industry',
    path: '/onboarding/industry',
    getParentRoute: () => SubdomainAppAuthRouteRoute,
  } as any)
const SubdomainAppAuthOnboardingPhoneRoute =
  SubdomainAppAuthOnboardingPhoneRouteImport.update({
    id: '/onboarding/phone',
    path: '/onboarding/phone',
    getParentRoute: () => SubdomainAppAuthRouteRoute,
  } as any)
const SubdomainAppAuthOnboardingSocialsRoute =
  SubdomainAppAuthOnboardingSocialsRouteImport.update({
    id: '/onboarding/socials',
    path: '/onboarding/socials',
    getParentRoute: () => SubdomainAppAuthRouteRoute,
  } as any)
const SubdomainAppAuthOnboardingWebsiteRoute =
  SubdomainAppAuthOnboardingWebsiteRouteImport.update({
    id: '/onboarding/website',
    path: '/onboarding/website',
    getParentRoute: () => SubdomainAppAuthRouteRoute,
  } as any)
const SubdomainAppAuthSignInIndexRoute =
  SubdomainAppAuthSignInIndexRouteImport.update({
    id: '/sign-in/',
    path: '/sign-in/',
    getParentRoute: () => SubdomainAppAuthRouteRoute,
  } as any)
const SubdomainAppAuthSignInEmailRoute =
  SubdomainAppAuthSignInEmailRouteImport.update({
    id: '/sign-in/email',
    path: '/sign-in/email',
    getParentRoute: () => SubdomainAppAuthRouteRoute,
  } as any)
const SubdomainAppAuthSignUpIndexRoute =
  SubdomainAppAuthSignUpIndexRouteImport.update({
    id: '/sign-up/',
    path: '/sign-up/',
    getParentRoute: () => SubdomainAppAuthRouteRoute,
  } as any)
const SubdomainAppAuthSignUpEmailRoute =
  SubdomainAppAuthSignUpEmailRouteImport.update({
    id: '/sign-up/email',
    path: '/sign-up/email',
    getParentRoute: () => SubdomainAppAuthRouteRoute,
  } as any)
const SubdomainAppClientProjectsIndexRoute =
  SubdomainAppClientProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => SubdomainAppClientRouteRoute,
  } as any)
const SubdomainAppClientProjectsProjectIdRoute =
  SubdomainAppClientProjectsProjectIdRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => SubdomainAppClientRouteRoute,
  } as any)
const SubdomainAppClientProjectsDeliverablesRoute =
  SubdomainAppClientProjectsDeliverablesRouteImport.update({
    id: '/projects/deliverables',
    path: '/projects/deliverables',
    getParentRoute: () => SubdomainAppClientRouteRoute,
  } as any)
const SubdomainAppClientSettingsNotificationsRoute =
  SubdomainAppClientSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => SubdomainAppClientSettingsRouteRoute,
  } as any)
const SubdomainAppClientSettingsProfileRoute =
  SubdomainAppClientSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => SubdomainAppClientSettingsRouteRoute,
  } as any)
const SubdomainAppClientSettingsSecurityRoute =
  SubdomainAppClientSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => SubdomainAppClientSettingsRouteRoute,
  } as any)
const SubdomainAppClientTasksTaskIdRoute =
  SubdomainAppClientTasksTaskIdRouteImport.update({
    id: '/tasks/$taskId',
    path: '/tasks/$taskId',
    getParentRoute: () => SubdomainAppClientRouteRoute,
  } as any)
const SubdomainAdminStaffBusinessesBusinessIdIndexRoute =
  SubdomainAdminStaffBusinessesBusinessIdIndexRouteImport.update({
    id: '/businesses/$businessId/',
    path: '/businesses/$businessId/',
    getParentRoute: () => SubdomainAdminStaffRouteRoute,
  } as any)
const SubdomainAdminStaffBusinessesBusinessIdDeliverablesRoute =
  SubdomainAdminStaffBusinessesBusinessIdDeliverablesRouteImport.update({
    id: '/businesses/$businessId/deliverables',
    path: '/businesses/$businessId/deliverables',
    getParentRoute: () => SubdomainAdminStaffRouteRoute,
  } as any)
const SubdomainAdminStaffBusinessesBusinessIdProjectsRoute =
  SubdomainAdminStaffBusinessesBusinessIdProjectsRouteImport.update({
    id: '/businesses/$businessId/projects',
    path: '/businesses/$businessId/projects',
    getParentRoute: () => SubdomainAdminStaffRouteRoute,
  } as any)
const SubdomainAdminStaffProjectsProjectIdIndexRoute =
  SubdomainAdminStaffProjectsProjectIdIndexRouteImport.update({
    id: '/projects/$projectId/',
    path: '/projects/$projectId/',
    getParentRoute: () => SubdomainAdminStaffRouteRoute,
  } as any)
const SubdomainAdminStaffSettingsWorkspaceAgencyRoute =
  SubdomainAdminStaffSettingsWorkspaceAgencyRouteImport.update({
    id: '/agency',
    path: '/agency',
    getParentRoute: () => SubdomainAdminStaffSettingsWorkspaceRouteRoute,
  } as any)
const SubdomainAdminStaffSettingsWorkspaceFlagsRoute =
  SubdomainAdminStaffSettingsWorkspaceFlagsRouteImport.update({
    id: '/flags',
    path: '/flags',
    getParentRoute: () => SubdomainAdminStaffSettingsWorkspaceRouteRoute,
  } as any)
const SubdomainAdminStaffSettingsWorkspaceIntegrationsRoute =
  SubdomainAdminStaffSettingsWorkspaceIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => SubdomainAdminStaffSettingsWorkspaceRouteRoute,
  } as any)
const SubdomainAdminStaffSettingsWorkspaceLimitsRoute =
  SubdomainAdminStaffSettingsWorkspaceLimitsRouteImport.update({
    id: '/limits',
    path: '/limits',
    getParentRoute: () => SubdomainAdminStaffSettingsWorkspaceRouteRoute,
  } as any)
const SubdomainAdminStaffSettingsWorkspaceMaintenanceRoute =
  SubdomainAdminStaffSettingsWorkspaceMaintenanceRouteImport.update({
    id: '/maintenance',
    path: '/maintenance',
    getParentRoute: () => SubdomainAdminStaffSettingsWorkspaceRouteRoute,
  } as any)
const SubdomainAdminStaffSettingsWorkspaceRolesRoute =
  SubdomainAdminStaffSettingsWorkspaceRolesRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => SubdomainAdminStaffSettingsWorkspaceRouteRoute,
  } as any)
const SubdomainAdminStaffSettingsWorkspaceSchedulingRoute =
  SubdomainAdminStaffSettingsWorkspaceSchedulingRouteImport.update({
    id: '/scheduling',
    path: '/scheduling',
    getParentRoute: () => SubdomainAdminStaffSettingsWorkspaceRouteRoute,
  } as any)
const SubdomainAdminStaffSettingsWorkspaceSecurityPolicyRoute =
  SubdomainAdminStaffSettingsWorkspaceSecurityPolicyRouteImport.update({
    id: '/security-policy',
    path: '/security-policy',
    getParentRoute: () => SubdomainAdminStaffSettingsWorkspaceRouteRoute,
  } as any)
const SubdomainAdminStaffSettingsWorkspaceStaffSecurityRoute =
  SubdomainAdminStaffSettingsWorkspaceStaffSecurityRouteImport.update({
    id: '/staff-security',
    path: '/staff-security',
    getParentRoute: () => SubdomainAdminStaffSettingsWorkspaceRouteRoute,
  } as any)
const SubdomainAdminStaffSettingsWorkspaceTeamNotificationsRoute =
  SubdomainAdminStaffSettingsWorkspaceTeamNotificationsRouteImport.update({
    id: '/team-notifications',
    path: '/team-notifications',
    getParentRoute: () => SubdomainAdminStaffSettingsWorkspaceRouteRoute,
  } as any)
const SubdomainAdminStaffTasksTaskIdIndexRoute =
  SubdomainAdminStaffTasksTaskIdIndexRouteImport.update({
    id: '/tasks/$taskId/',
    path: '/tasks/$taskId/',
    getParentRoute: () => SubdomainAdminStaffRouteRoute,
  } as any)
const SubdomainAdminStaffTasksTaskIdEditRoute =
  SubdomainAdminStaffTasksTaskIdEditRouteImport.update({
    id: '/tasks/$taskId/edit',
    path: '/tasks/$taskId/edit',
    getParentRoute: () => SubdomainAdminStaffRouteRoute,
  } as any)
const SubdomainAdminStaffTasksTaskIdSubmitRoute =
  SubdomainAdminStaffTasksTaskIdSubmitRouteImport.update({
    id: '/tasks/$taskId/submit',
    path: '/tasks/$taskId/submit',
    getParentRoute: () => SubdomainAdminStaffRouteRoute,
  } as any)
const SubdomainAdminStaffWorkbenchReviewsIndexRoute =
  SubdomainAdminStaffWorkbenchReviewsIndexRouteImport.update({
    id: '/workbench/reviews/',
    path: '/workbench/reviews/',
    getParentRoute: () => SubdomainAdminStaffRouteRoute,
  } as any)
const SubdomainAdminStaffWorkbenchReviewsTaskIdRoute =
  SubdomainAdminStaffWorkbenchReviewsTaskIdRouteImport.update({
    id: '/workbench/reviews/$taskId',
    path: '/workbench/reviews/$taskId',
    getParentRoute: () => SubdomainAdminStaffRouteRoute,
  } as any)
const SubdomainAppClientWorkReviewTaskIdRoute =
  SubdomainAppClientWorkReviewTaskIdRouteImport.update({
    id: '/work/review/$taskId',
    path: '/work/review/$taskId',
    getParentRoute: () => SubdomainAppClientRouteRoute,
  } as any)
const SubdomainAdminStaffProjectsProjectIdTasksNewRoute =
  SubdomainAdminStaffProjectsProjectIdTasksNewRouteImport.update({
    id: '/projects/$projectId/tasks/new',
    path: '/projects/$projectId/tasks/new',
    getParentRoute: () => SubdomainAdminStaffRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/subdomain/admin': typeof SubdomainAdminRouteRouteWithChildren
  '/subdomain/app': typeof SubdomainAppRouteRouteWithChildren
  '/subdomain/': typeof SubdomainIndexRoute
  '/subdomain/app/audit': typeof SubdomainAppAuditRoute
  '/subdomain/dev/graph': typeof SubdomainDevGraphRoute
  '/subdomain/dev/': typeof SubdomainDevIndexRoute
  '/subdomain/admin/settings': typeof SubdomainAdminStaffSettingsRouteRouteWithChildren
  '/subdomain/app/settings': typeof SubdomainAppClientSettingsRouteRouteWithChildren
  '/subdomain/admin/admin-login': typeof SubdomainAdminAuthAdminLoginRoute
  '/subdomain/admin/forgot-password': typeof SubdomainAdminAuthForgotPasswordRoute
  '/subdomain/admin/invite': typeof SubdomainAdminAuthInviteRoute
  '/subdomain/admin/two-factor': typeof SubdomainAdminAuthTwoFactorRoute
  '/subdomain/app/forgot-password': typeof SubdomainAppAuthForgotPasswordRoute
  '/subdomain/app/two-factor': typeof SubdomainAppAuthTwoFactorRoute
  '/subdomain/app/verify-email': typeof SubdomainAppAuthVerifyEmailRoute
  '/subdomain/app/welcome': typeof SubdomainAppAuthWelcomeRoute
  '/subdomain/admin/': typeof SubdomainAdminStaffIndexRoute
  '/subdomain/app/': typeof SubdomainAppClientIndexRoute
  '/subdomain/admin/settings/workspace': typeof SubdomainAdminStaffSettingsWorkspaceRouteRouteWithChildren
  '/subdomain/admin/settings/availability': typeof SubdomainAdminStaffSettingsAvailabilityRoute
  '/subdomain/admin/settings/connections': typeof SubdomainAdminStaffSettingsConnectionsRoute
  '/subdomain/admin/settings/notifications': typeof SubdomainAdminStaffSettingsNotificationsRoute
  '/subdomain/admin/settings/profile': typeof SubdomainAdminStaffSettingsProfileRoute
  '/subdomain/admin/settings/security': typeof SubdomainAdminStaffSettingsSecurityRoute
  '/subdomain/admin/staff/$staffId': typeof SubdomainAdminStaffStaffStaffIdRoute
  '/subdomain/app/onboarding/business': typeof SubdomainAppAuthOnboardingBusinessRoute
  '/subdomain/app/onboarding/industry': typeof SubdomainAppAuthOnboardingIndustryRoute
  '/subdomain/app/onboarding/phone': typeof SubdomainAppAuthOnboardingPhoneRoute
  '/subdomain/app/onboarding/socials': typeof SubdomainAppAuthOnboardingSocialsRoute
  '/subdomain/app/onboarding/website': typeof SubdomainAppAuthOnboardingWebsiteRoute
  '/subdomain/app/sign-in/email': typeof SubdomainAppAuthSignInEmailRoute
  '/subdomain/app/sign-up/email': typeof SubdomainAppAuthSignUpEmailRoute
  '/subdomain/app/projects/$projectId': typeof SubdomainAppClientProjectsProjectIdRoute
  '/subdomain/app/projects/deliverables': typeof SubdomainAppClientProjectsDeliverablesRoute
  '/subdomain/app/settings/notifications': typeof SubdomainAppClientSettingsNotificationsRoute
  '/subdomain/app/settings/profile': typeof SubdomainAppClientSettingsProfileRoute
  '/subdomain/app/settings/security': typeof SubdomainAppClientSettingsSecurityRoute
  '/subdomain/app/tasks/$taskId': typeof SubdomainAppClientTasksTaskIdRoute
  '/subdomain/admin/businesses/': typeof SubdomainAdminStaffBusinessesIndexRoute
  '/subdomain/admin/settings/': typeof SubdomainAdminStaffSettingsIndexRoute
  '/subdomain/admin/staff/': typeof SubdomainAdminStaffStaffIndexRoute
  '/subdomain/app/sign-in/': typeof SubdomainAppAuthSignInIndexRoute
  '/subdomain/app/sign-up/': typeof SubdomainAppAuthSignUpIndexRoute
  '/subdomain/app/projects/': typeof SubdomainAppClientProjectsIndexRoute
  '/subdomain/admin/businesses/$businessId/deliverables': typeof SubdomainAdminStaffBusinessesBusinessIdDeliverablesRoute
  '/subdomain/admin/businesses/$businessId/projects': typeof SubdomainAdminStaffBusinessesBusinessIdProjectsRoute
  '/subdomain/admin/settings/workspace/agency': typeof SubdomainAdminStaffSettingsWorkspaceAgencyRoute
  '/subdomain/admin/settings/workspace/flags': typeof SubdomainAdminStaffSettingsWorkspaceFlagsRoute
  '/subdomain/admin/settings/workspace/integrations': typeof SubdomainAdminStaffSettingsWorkspaceIntegrationsRoute
  '/subdomain/admin/settings/workspace/limits': typeof SubdomainAdminStaffSettingsWorkspaceLimitsRoute
  '/subdomain/admin/settings/workspace/maintenance': typeof SubdomainAdminStaffSettingsWorkspaceMaintenanceRoute
  '/subdomain/admin/settings/workspace/roles': typeof SubdomainAdminStaffSettingsWorkspaceRolesRoute
  '/subdomain/admin/settings/workspace/scheduling': typeof SubdomainAdminStaffSettingsWorkspaceSchedulingRoute
  '/subdomain/admin/settings/workspace/security-policy': typeof SubdomainAdminStaffSettingsWorkspaceSecurityPolicyRoute
  '/subdomain/admin/settings/workspace/staff-security': typeof SubdomainAdminStaffSettingsWorkspaceStaffSecurityRoute
  '/subdomain/admin/settings/workspace/team-notifications': typeof SubdomainAdminStaffSettingsWorkspaceTeamNotificationsRoute
  '/subdomain/admin/tasks/$taskId/edit': typeof SubdomainAdminStaffTasksTaskIdEditRoute
  '/subdomain/admin/tasks/$taskId/submit': typeof SubdomainAdminStaffTasksTaskIdSubmitRoute
  '/subdomain/admin/workbench/reviews/$taskId': typeof SubdomainAdminStaffWorkbenchReviewsTaskIdRoute
  '/subdomain/app/work/review/$taskId': typeof SubdomainAppClientWorkReviewTaskIdRoute
  '/subdomain/admin/businesses/$businessId/': typeof SubdomainAdminStaffBusinessesBusinessIdIndexRoute
  '/subdomain/admin/projects/$projectId/': typeof SubdomainAdminStaffProjectsProjectIdIndexRoute
  '/subdomain/admin/tasks/$taskId/': typeof SubdomainAdminStaffTasksTaskIdIndexRoute
  '/subdomain/admin/workbench/reviews/': typeof SubdomainAdminStaffWorkbenchReviewsIndexRoute
  '/subdomain/admin/projects/$projectId/tasks/new': typeof SubdomainAdminStaffProjectsProjectIdTasksNewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/subdomain/admin': typeof SubdomainAdminStaffIndexRoute
  '/subdomain/app': typeof SubdomainAppClientIndexRoute
  '/subdomain': typeof SubdomainIndexRoute
  '/subdomain/app/audit': typeof SubdomainAppAuditRoute
  '/subdomain/dev/graph': typeof SubdomainDevGraphRoute
  '/subdomain/dev': typeof SubdomainDevIndexRoute
  '/subdomain/app/settings': typeof SubdomainAppClientSettingsRouteRouteWithChildren
  '/subdomain/admin/admin-login': typeof SubdomainAdminAuthAdminLoginRoute
  '/subdomain/admin/forgot-password': typeof SubdomainAdminAuthForgotPasswordRoute
  '/subdomain/admin/invite': typeof SubdomainAdminAuthInviteRoute
  '/subdomain/admin/two-factor': typeof SubdomainAdminAuthTwoFactorRoute
  '/subdomain/app/forgot-password': typeof SubdomainAppAuthForgotPasswordRoute
  '/subdomain/app/two-factor': typeof SubdomainAppAuthTwoFactorRoute
  '/subdomain/app/verify-email': typeof SubdomainAppAuthVerifyEmailRoute
  '/subdomain/app/welcome': typeof SubdomainAppAuthWelcomeRoute
  '/subdomain/admin/settings/workspace': typeof SubdomainAdminStaffSettingsWorkspaceRouteRouteWithChildren
  '/subdomain/admin/settings/availability': typeof SubdomainAdminStaffSettingsAvailabilityRoute
  '/subdomain/admin/settings/connections': typeof SubdomainAdminStaffSettingsConnectionsRoute
  '/subdomain/admin/settings/notifications': typeof SubdomainAdminStaffSettingsNotificationsRoute
  '/subdomain/admin/settings/profile': typeof SubdomainAdminStaffSettingsProfileRoute
  '/subdomain/admin/settings/security': typeof SubdomainAdminStaffSettingsSecurityRoute
  '/subdomain/admin/staff/$staffId': typeof SubdomainAdminStaffStaffStaffIdRoute
  '/subdomain/app/onboarding/business': typeof SubdomainAppAuthOnboardingBusinessRoute
  '/subdomain/app/onboarding/industry': typeof SubdomainAppAuthOnboardingIndustryRoute
  '/subdomain/app/onboarding/phone': typeof SubdomainAppAuthOnboardingPhoneRoute
  '/subdomain/app/onboarding/socials': typeof SubdomainAppAuthOnboardingSocialsRoute
  '/subdomain/app/onboarding/website': typeof SubdomainAppAuthOnboardingWebsiteRoute
  '/subdomain/app/sign-in/email': typeof SubdomainAppAuthSignInEmailRoute
  '/subdomain/app/sign-up/email': typeof SubdomainAppAuthSignUpEmailRoute
  '/subdomain/app/projects/$projectId': typeof SubdomainAppClientProjectsProjectIdRoute
  '/subdomain/app/projects/deliverables': typeof SubdomainAppClientProjectsDeliverablesRoute
  '/subdomain/app/settings/notifications': typeof SubdomainAppClientSettingsNotificationsRoute
  '/subdomain/app/settings/profile': typeof SubdomainAppClientSettingsProfileRoute
  '/subdomain/app/settings/security': typeof SubdomainAppClientSettingsSecurityRoute
  '/subdomain/app/tasks/$taskId': typeof SubdomainAppClientTasksTaskIdRoute
  '/subdomain/admin/businesses': typeof SubdomainAdminStaffBusinessesIndexRoute
  '/subdomain/admin/settings': typeof SubdomainAdminStaffSettingsIndexRoute
  '/subdomain/admin/staff': typeof SubdomainAdminStaffStaffIndexRoute
  '/subdomain/app/sign-in': typeof SubdomainAppAuthSignInIndexRoute
  '/subdomain/app/sign-up': typeof SubdomainAppAuthSignUpIndexRoute
  '/subdomain/app/projects': typeof SubdomainAppClientProjectsIndexRoute
  '/subdomain/admin/businesses/$businessId/deliverables': typeof SubdomainAdminStaffBusinessesBusinessIdDeliverablesRoute
  '/subdomain/admin/businesses/$businessId/projects': typeof SubdomainAdminStaffBusinessesBusinessIdProjectsRoute
  '/subdomain/admin/settings/workspace/agency': typeof SubdomainAdminStaffSettingsWorkspaceAgencyRoute
  '/subdomain/admin/settings/workspace/flags': typeof SubdomainAdminStaffSettingsWorkspaceFlagsRoute
  '/subdomain/admin/settings/workspace/integrations': typeof SubdomainAdminStaffSettingsWorkspaceIntegrationsRoute
  '/subdomain/admin/settings/workspace/limits': typeof SubdomainAdminStaffSettingsWorkspaceLimitsRoute
  '/subdomain/admin/settings/workspace/maintenance': typeof SubdomainAdminStaffSettingsWorkspaceMaintenanceRoute
  '/subdomain/admin/settings/workspace/roles': typeof SubdomainAdminStaffSettingsWorkspaceRolesRoute
  '/subdomain/admin/settings/workspace/scheduling': typeof SubdomainAdminStaffSettingsWorkspaceSchedulingRoute
  '/subdomain/admin/settings/workspace/security-policy': typeof SubdomainAdminStaffSettingsWorkspaceSecurityPolicyRoute
  '/subdomain/admin/settings/workspace/staff-security': typeof SubdomainAdminStaffSettingsWorkspaceStaffSecurityRoute
  '/subdomain/admin/settings/workspace/team-notifications': typeof SubdomainAdminStaffSettingsWorkspaceTeamNotificationsRoute
  '/subdomain/admin/tasks/$taskId/edit': typeof SubdomainAdminStaffTasksTaskIdEditRoute
  '/subdomain/admin/tasks/$taskId/submit': typeof SubdomainAdminStaffTasksTaskIdSubmitRoute
  '/subdomain/admin/workbench/reviews/$taskId': typeof SubdomainAdminStaffWorkbenchReviewsTaskIdRoute
  '/subdomain/app/work/review/$taskId': typeof SubdomainAppClientWorkReviewTaskIdRoute
  '/subdomain/admin/businesses/$businessId': typeof SubdomainAdminStaffBusinessesBusinessIdIndexRoute
  '/subdomain/admin/projects/$projectId': typeof SubdomainAdminStaffProjectsProjectIdIndexRoute
  '/subdomain/admin/tasks/$taskId': typeof SubdomainAdminStaffTasksTaskIdIndexRoute
  '/subdomain/admin/workbench/reviews': typeof SubdomainAdminStaffWorkbenchReviewsIndexRoute
  '/subdomain/admin/projects/$projectId/tasks/new': typeof SubdomainAdminStaffProjectsProjectIdTasksNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/subdomain/admin': typeof SubdomainAdminRouteRouteWithChildren
  '/subdomain/app': typeof SubdomainAppRouteRouteWithChildren
  '/subdomain/': typeof SubdomainIndexRoute
  '/subdomain/admin/_auth': typeof SubdomainAdminAuthRouteRouteWithChildren
  '/subdomain/admin/_staff': typeof SubdomainAdminStaffRouteRouteWithChildren
  '/subdomain/app/_auth': typeof SubdomainAppAuthRouteRouteWithChildren
  '/subdomain/app/_client': typeof SubdomainAppClientRouteRouteWithChildren
  '/subdomain/app/audit': typeof SubdomainAppAuditRoute
  '/subdomain/dev/graph': typeof SubdomainDevGraphRoute
  '/subdomain/dev/': typeof SubdomainDevIndexRoute
  '/subdomain/admin/_staff/settings': typeof SubdomainAdminStaffSettingsRouteRouteWithChildren
  '/subdomain/app/_client/settings': typeof SubdomainAppClientSettingsRouteRouteWithChildren
  '/subdomain/admin/_auth/admin-login': typeof SubdomainAdminAuthAdminLoginRoute
  '/subdomain/admin/_auth/forgot-password': typeof SubdomainAdminAuthForgotPasswordRoute
  '/subdomain/admin/_auth/invite': typeof SubdomainAdminAuthInviteRoute
  '/subdomain/admin/_auth/two-factor': typeof SubdomainAdminAuthTwoFactorRoute
  '/subdomain/app/_auth/forgot-password': typeof SubdomainAppAuthForgotPasswordRoute
  '/subdomain/app/_auth/two-factor': typeof SubdomainAppAuthTwoFactorRoute
  '/subdomain/app/_auth/verify-email': typeof SubdomainAppAuthVerifyEmailRoute
  '/subdomain/app/_auth/welcome': typeof SubdomainAppAuthWelcomeRoute
  '/subdomain/admin/_staff/': typeof SubdomainAdminStaffIndexRoute
  '/subdomain/app/_client/': typeof SubdomainAppClientIndexRoute
  '/subdomain/admin/_staff/settings/workspace': typeof SubdomainAdminStaffSettingsWorkspaceRouteRouteWithChildren
  '/subdomain/admin/_staff/settings/availability': typeof SubdomainAdminStaffSettingsAvailabilityRoute
  '/subdomain/admin/_staff/settings/connections': typeof SubdomainAdminStaffSettingsConnectionsRoute
  '/subdomain/admin/_staff/settings/notifications': typeof SubdomainAdminStaffSettingsNotificationsRoute
  '/subdomain/admin/_staff/settings/profile': typeof SubdomainAdminStaffSettingsProfileRoute
  '/subdomain/admin/_staff/settings/security': typeof SubdomainAdminStaffSettingsSecurityRoute
  '/subdomain/admin/_staff/staff/$staffId': typeof SubdomainAdminStaffStaffStaffIdRoute
  '/subdomain/app/_auth/onboarding/business': typeof SubdomainAppAuthOnboardingBusinessRoute
  '/subdomain/app/_auth/onboarding/industry': typeof SubdomainAppAuthOnboardingIndustryRoute
  '/subdomain/app/_auth/onboarding/phone': typeof SubdomainAppAuthOnboardingPhoneRoute
  '/subdomain/app/_auth/onboarding/socials': typeof SubdomainAppAuthOnboardingSocialsRoute
  '/subdomain/app/_auth/onboarding/website': typeof SubdomainAppAuthOnboardingWebsiteRoute
  '/subdomain/app/_auth/sign-in/email': typeof SubdomainAppAuthSignInEmailRoute
  '/subdomain/app/_auth/sign-up/email': typeof SubdomainAppAuthSignUpEmailRoute
  '/subdomain/app/_client/projects/$projectId': typeof SubdomainAppClientProjectsProjectIdRoute
  '/subdomain/app/_client/projects/deliverables': typeof SubdomainAppClientProjectsDeliverablesRoute
  '/subdomain/app/_client/settings/notifications': typeof SubdomainAppClientSettingsNotificationsRoute
  '/subdomain/app/_client/settings/profile': typeof SubdomainAppClientSettingsProfileRoute
  '/subdomain/app/_client/settings/security': typeof SubdomainAppClientSettingsSecurityRoute
  '/subdomain/app/_client/tasks/$taskId': typeof SubdomainAppClientTasksTaskIdRoute
  '/subdomain/admin/_staff/businesses/': typeof SubdomainAdminStaffBusinessesIndexRoute
  '/subdomain/admin/_staff/settings/': typeof SubdomainAdminStaffSettingsIndexRoute
  '/subdomain/admin/_staff/staff/': typeof SubdomainAdminStaffStaffIndexRoute
  '/subdomain/app/_auth/sign-in/': typeof SubdomainAppAuthSignInIndexRoute
  '/subdomain/app/_auth/sign-up/': typeof SubdomainAppAuthSignUpIndexRoute
  '/subdomain/app/_client/projects/': typeof SubdomainAppClientProjectsIndexRoute
  '/subdomain/admin/_staff/businesses/$businessId/deliverables': typeof SubdomainAdminStaffBusinessesBusinessIdDeliverablesRoute
  '/subdomain/admin/_staff/businesses/$businessId/projects': typeof SubdomainAdminStaffBusinessesBusinessIdProjectsRoute
  '/subdomain/admin/_staff/settings/workspace/agency': typeof SubdomainAdminStaffSettingsWorkspaceAgencyRoute
  '/subdomain/admin/_staff/settings/workspace/flags': typeof SubdomainAdminStaffSettingsWorkspaceFlagsRoute
  '/subdomain/admin/_staff/settings/workspace/integrations': typeof SubdomainAdminStaffSettingsWorkspaceIntegrationsRoute
  '/subdomain/admin/_staff/settings/workspace/limits': typeof SubdomainAdminStaffSettingsWorkspaceLimitsRoute
  '/subdomain/admin/_staff/settings/workspace/maintenance': typeof SubdomainAdminStaffSettingsWorkspaceMaintenanceRoute
  '/subdomain/admin/_staff/settings/workspace/roles': typeof SubdomainAdminStaffSettingsWorkspaceRolesRoute
  '/subdomain/admin/_staff/settings/workspace/scheduling': typeof SubdomainAdminStaffSettingsWorkspaceSchedulingRoute
  '/subdomain/admin/_staff/settings/workspace/security-policy': typeof SubdomainAdminStaffSettingsWorkspaceSecurityPolicyRoute
  '/subdomain/admin/_staff/settings/workspace/staff-security': typeof SubdomainAdminStaffSettingsWorkspaceStaffSecurityRoute
  '/subdomain/admin/_staff/settings/workspace/team-notifications': typeof SubdomainAdminStaffSettingsWorkspaceTeamNotificationsRoute
  '/subdomain/admin/_staff/tasks/$taskId/edit': typeof SubdomainAdminStaffTasksTaskIdEditRoute
  '/subdomain/admin/_staff/tasks/$taskId/submit': typeof SubdomainAdminStaffTasksTaskIdSubmitRoute
  '/subdomain/admin/_staff/workbench/reviews/$taskId': typeof SubdomainAdminStaffWorkbenchReviewsTaskIdRoute
  '/subdomain/app/_client/work/review/$taskId': typeof SubdomainAppClientWorkReviewTaskIdRoute
  '/subdomain/admin/_staff/businesses/$businessId/': typeof SubdomainAdminStaffBusinessesBusinessIdIndexRoute
  '/subdomain/admin/_staff/projects/$projectId/': typeof SubdomainAdminStaffProjectsProjectIdIndexRoute
  '/subdomain/admin/_staff/tasks/$taskId/': typeof SubdomainAdminStaffTasksTaskIdIndexRoute
  '/subdomain/admin/_staff/workbench/reviews/': typeof SubdomainAdminStaffWorkbenchReviewsIndexRoute
  '/subdomain/admin/_staff/projects/$projectId/tasks/new': typeof SubdomainAdminStaffProjectsProjectIdTasksNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/subdomain/admin'
    | '/subdomain/app'
    | '/subdomain/'
    | '/subdomain/app/audit'
    | '/subdomain/dev/graph'
    | '/subdomain/dev/'
    | '/subdomain/admin/settings'
    | '/subdomain/app/settings'
    | '/subdomain/admin/admin-login'
    | '/subdomain/admin/forgot-password'
    | '/subdomain/admin/invite'
    | '/subdomain/admin/two-factor'
    | '/subdomain/app/forgot-password'
    | '/subdomain/app/two-factor'
    | '/subdomain/app/verify-email'
    | '/subdomain/app/welcome'
    | '/subdomain/admin/'
    | '/subdomain/app/'
    | '/subdomain/admin/settings/workspace'
    | '/subdomain/admin/settings/availability'
    | '/subdomain/admin/settings/connections'
    | '/subdomain/admin/settings/notifications'
    | '/subdomain/admin/settings/profile'
    | '/subdomain/admin/settings/security'
    | '/subdomain/admin/staff/$staffId'
    | '/subdomain/app/onboarding/business'
    | '/subdomain/app/onboarding/industry'
    | '/subdomain/app/onboarding/phone'
    | '/subdomain/app/onboarding/socials'
    | '/subdomain/app/onboarding/website'
    | '/subdomain/app/sign-in/email'
    | '/subdomain/app/sign-up/email'
    | '/subdomain/app/projects/$projectId'
    | '/subdomain/app/projects/deliverables'
    | '/subdomain/app/settings/notifications'
    | '/subdomain/app/settings/profile'
    | '/subdomain/app/settings/security'
    | '/subdomain/app/tasks/$taskId'
    | '/subdomain/admin/businesses/'
    | '/subdomain/admin/settings/'
    | '/subdomain/admin/staff/'
    | '/subdomain/app/sign-in/'
    | '/subdomain/app/sign-up/'
    | '/subdomain/app/projects/'
    | '/subdomain/admin/businesses/$businessId/deliverables'
    | '/subdomain/admin/businesses/$businessId/projects'
    | '/subdomain/admin/settings/workspace/agency'
    | '/subdomain/admin/settings/workspace/flags'
    | '/subdomain/admin/settings/workspace/integrations'
    | '/subdomain/admin/settings/workspace/limits'
    | '/subdomain/admin/settings/workspace/maintenance'
    | '/subdomain/admin/settings/workspace/roles'
    | '/subdomain/admin/settings/workspace/scheduling'
    | '/subdomain/admin/settings/workspace/security-policy'
    | '/subdomain/admin/settings/workspace/staff-security'
    | '/subdomain/admin/settings/workspace/team-notifications'
    | '/subdomain/admin/tasks/$taskId/edit'
    | '/subdomain/admin/tasks/$taskId/submit'
    | '/subdomain/admin/workbench/reviews/$taskId'
    | '/subdomain/app/work/review/$taskId'
    | '/subdomain/admin/businesses/$businessId/'
    | '/subdomain/admin/projects/$projectId/'
    | '/subdomain/admin/tasks/$taskId/'
    | '/subdomain/admin/workbench/reviews/'
    | '/subdomain/admin/projects/$projectId/tasks/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/subdomain/admin'
    | '/subdomain/app'
    | '/subdomain'
    | '/subdomain/app/audit'
    | '/subdomain/dev/graph'
    | '/subdomain/dev'
    | '/subdomain/app/settings'
    | '/subdomain/admin/admin-login'
    | '/subdomain/admin/forgot-password'
    | '/subdomain/admin/invite'
    | '/subdomain/admin/two-factor'
    | '/subdomain/app/forgot-password'
    | '/subdomain/app/two-factor'
    | '/subdomain/app/verify-email'
    | '/subdomain/app/welcome'
    | '/subdomain/admin/settings/workspace'
    | '/subdomain/admin/settings/availability'
    | '/subdomain/admin/settings/connections'
    | '/subdomain/admin/settings/notifications'
    | '/subdomain/admin/settings/profile'
    | '/subdomain/admin/settings/security'
    | '/subdomain/admin/staff/$staffId'
    | '/subdomain/app/onboarding/business'
    | '/subdomain/app/onboarding/industry'
    | '/subdomain/app/onboarding/phone'
    | '/subdomain/app/onboarding/socials'
    | '/subdomain/app/onboarding/website'
    | '/subdomain/app/sign-in/email'
    | '/subdomain/app/sign-up/email'
    | '/subdomain/app/projects/$projectId'
    | '/subdomain/app/projects/deliverables'
    | '/subdomain/app/settings/notifications'
    | '/subdomain/app/settings/profile'
    | '/subdomain/app/settings/security'
    | '/subdomain/app/tasks/$taskId'
    | '/subdomain/admin/businesses'
    | '/subdomain/admin/settings'
    | '/subdomain/admin/staff'
    | '/subdomain/app/sign-in'
    | '/subdomain/app/sign-up'
    | '/subdomain/app/projects'
    | '/subdomain/admin/businesses/$businessId/deliverables'
    | '/subdomain/admin/businesses/$businessId/projects'
    | '/subdomain/admin/settings/workspace/agency'
    | '/subdomain/admin/settings/workspace/flags'
    | '/subdomain/admin/settings/workspace/integrations'
    | '/subdomain/admin/settings/workspace/limits'
    | '/subdomain/admin/settings/workspace/maintenance'
    | '/subdomain/admin/settings/workspace/roles'
    | '/subdomain/admin/settings/workspace/scheduling'
    | '/subdomain/admin/settings/workspace/security-policy'
    | '/subdomain/admin/settings/workspace/staff-security'
    | '/subdomain/admin/settings/workspace/team-notifications'
    | '/subdomain/admin/tasks/$taskId/edit'
    | '/subdomain/admin/tasks/$taskId/submit'
    | '/subdomain/admin/workbench/reviews/$taskId'
    | '/subdomain/app/work/review/$taskId'
    | '/subdomain/admin/businesses/$businessId'
    | '/subdomain/admin/projects/$projectId'
    | '/subdomain/admin/tasks/$taskId'
    | '/subdomain/admin/workbench/reviews'
    | '/subdomain/admin/projects/$projectId/tasks/new'
  id:
    | '__root__'
    | '/'
    | '/subdomain/admin'
    | '/subdomain/app'
    | '/subdomain/'
    | '/subdomain/admin/_auth'
    | '/subdomain/admin/_staff'
    | '/subdomain/app/_auth'
    | '/subdomain/app/_client'
    | '/subdomain/app/audit'
    | '/subdomain/dev/graph'
    | '/subdomain/dev/'
    | '/subdomain/admin/_staff/settings'
    | '/subdomain/app/_client/settings'
    | '/subdomain/admin/_auth/admin-login'
    | '/subdomain/admin/_auth/forgot-password'
    | '/subdomain/admin/_auth/invite'
    | '/subdomain/admin/_auth/two-factor'
    | '/subdomain/app/_auth/forgot-password'
    | '/subdomain/app/_auth/two-factor'
    | '/subdomain/app/_auth/verify-email'
    | '/subdomain/app/_auth/welcome'
    | '/subdomain/admin/_staff/'
    | '/subdomain/app/_client/'
    | '/subdomain/admin/_staff/settings/workspace'
    | '/subdomain/admin/_staff/settings/availability'
    | '/subdomain/admin/_staff/settings/connections'
    | '/subdomain/admin/_staff/settings/notifications'
    | '/subdomain/admin/_staff/settings/profile'
    | '/subdomain/admin/_staff/settings/security'
    | '/subdomain/admin/_staff/staff/$staffId'
    | '/subdomain/app/_auth/onboarding/business'
    | '/subdomain/app/_auth/onboarding/industry'
    | '/subdomain/app/_auth/onboarding/phone'
    | '/subdomain/app/_auth/onboarding/socials'
    | '/subdomain/app/_auth/onboarding/website'
    | '/subdomain/app/_auth/sign-in/email'
    | '/subdomain/app/_auth/sign-up/email'
    | '/subdomain/app/_client/projects/$projectId'
    | '/subdomain/app/_client/projects/deliverables'
    | '/subdomain/app/_client/settings/notifications'
    | '/subdomain/app/_client/settings/profile'
    | '/subdomain/app/_client/settings/security'
    | '/subdomain/app/_client/tasks/$taskId'
    | '/subdomain/admin/_staff/businesses/'
    | '/subdomain/admin/_staff/settings/'
    | '/subdomain/admin/_staff/staff/'
    | '/subdomain/app/_auth/sign-in/'
    | '/subdomain/app/_auth/sign-up/'
    | '/subdomain/app/_client/projects/'
    | '/subdomain/admin/_staff/businesses/$businessId/deliverables'
    | '/subdomain/admin/_staff/businesses/$businessId/projects'
    | '/subdomain/admin/_staff/settings/workspace/agency'
    | '/subdomain/admin/_staff/settings/workspace/flags'
    | '/subdomain/admin/_staff/settings/workspace/integrations'
    | '/subdomain/admin/_staff/settings/workspace/limits'
    | '/subdomain/admin/_staff/settings/workspace/maintenance'
    | '/subdomain/admin/_staff/settings/workspace/roles'
    | '/subdomain/admin/_staff/settings/workspace/scheduling'
    | '/subdomain/admin/_staff/settings/workspace/security-policy'
    | '/subdomain/admin/_staff/settings/workspace/staff-security'
    | '/subdomain/admin/_staff/settings/workspace/team-notifications'
    | '/subdomain/admin/_staff/tasks/$taskId/edit'
    | '/subdomain/admin/_staff/tasks/$taskId/submit'
    | '/subdomain/admin/_staff/workbench/reviews/$taskId'
    | '/subdomain/app/_client/work/review/$taskId'
    | '/subdomain/admin/_staff/businesses/$businessId/'
    | '/subdomain/admin/_staff/projects/$projectId/'
    | '/subdomain/admin/_staff/tasks/$taskId/'
    | '/subdomain/admin/_staff/workbench/reviews/'
    | '/subdomain/admin/_staff/projects/$projectId/tasks/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SubdomainAdminRouteRoute: typeof SubdomainAdminRouteRouteWithChildren
  SubdomainAppRouteRoute: typeof SubdomainAppRouteRouteWithChildren
  SubdomainIndexRoute: typeof SubdomainIndexRoute
  SubdomainDevGraphRoute: typeof SubdomainDevGraphRoute
  SubdomainDevIndexRoute: typeof SubdomainDevIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subdomain/': {
      id: '/subdomain/'
      path: '/subdomain'
      fullPath: '/subdomain/'
      preLoaderRoute: typeof SubdomainIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subdomain/admin': {
      id: '/subdomain/admin'
      path: '/subdomain/admin'
      fullPath: '/subdomain/admin'
      preLoaderRoute: typeof SubdomainAdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subdomain/app': {
      id: '/subdomain/app'
      path: '/subdomain/app'
      fullPath: '/subdomain/app'
      preLoaderRoute: typeof SubdomainAppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subdomain/admin/_auth': {
      id: '/subdomain/admin/_auth'
      path: ''
      fullPath: '/subdomain/admin'
      preLoaderRoute: typeof SubdomainAdminAuthRouteRouteImport
      parentRoute: typeof SubdomainAdminRouteRoute
    }
    '/subdomain/admin/_staff': {
      id: '/subdomain/admin/_staff'
      path: ''
      fullPath: '/subdomain/admin'
      preLoaderRoute: typeof SubdomainAdminStaffRouteRouteImport
      parentRoute: typeof SubdomainAdminRouteRoute
    }
    '/subdomain/app/_auth': {
      id: '/subdomain/app/_auth'
      path: ''
      fullPath: '/subdomain/app'
      preLoaderRoute: typeof SubdomainAppAuthRouteRouteImport
      parentRoute: typeof SubdomainAppRouteRoute
    }
    '/subdomain/app/_client': {
      id: '/subdomain/app/_client'
      path: ''
      fullPath: '/subdomain/app'
      preLoaderRoute: typeof SubdomainAppClientRouteRouteImport
      parentRoute: typeof SubdomainAppRouteRoute
    }
    '/subdomain/app/audit': {
      id: '/subdomain/app/audit'
      path: '/audit'
      fullPath: '/subdomain/app/audit'
      preLoaderRoute: typeof SubdomainAppAuditRouteImport
      parentRoute: typeof SubdomainAppRouteRoute
    }
    '/subdomain/dev/': {
      id: '/subdomain/dev/'
      path: '/subdomain/dev'
      fullPath: '/subdomain/dev/'
      preLoaderRoute: typeof SubdomainDevIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subdomain/dev/graph': {
      id: '/subdomain/dev/graph'
      path: '/subdomain/dev/graph'
      fullPath: '/subdomain/dev/graph'
      preLoaderRoute: typeof SubdomainDevGraphRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subdomain/admin/_auth/admin-login': {
      id: '/subdomain/admin/_auth/admin-login'
      path: '/admin-login'
      fullPath: '/subdomain/admin/admin-login'
      preLoaderRoute: typeof SubdomainAdminAuthAdminLoginRouteImport
      parentRoute: typeof SubdomainAdminAuthRouteRoute
    }
    '/subdomain/admin/_auth/forgot-password': {
      id: '/subdomain/admin/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/subdomain/admin/forgot-password'
      preLoaderRoute: typeof SubdomainAdminAuthForgotPasswordRouteImport
      parentRoute: typeof SubdomainAdminAuthRouteRoute
    }
    '/subdomain/admin/_auth/invite': {
      id: '/subdomain/admin/_auth/invite'
      path: '/invite'
      fullPath: '/subdomain/admin/invite'
      preLoaderRoute: typeof SubdomainAdminAuthInviteRouteImport
      parentRoute: typeof SubdomainAdminAuthRouteRoute
    }
    '/subdomain/admin/_auth/two-factor': {
      id: '/subdomain/admin/_auth/two-factor'
      path: '/two-factor'
      fullPath: '/subdomain/admin/two-factor'
      preLoaderRoute: typeof SubdomainAdminAuthTwoFactorRouteImport
      parentRoute: typeof SubdomainAdminAuthRouteRoute
    }
    '/subdomain/admin/_staff/': {
      id: '/subdomain/admin/_staff/'
      path: '/'
      fullPath: '/subdomain/admin/'
      preLoaderRoute: typeof SubdomainAdminStaffIndexRouteImport
      parentRoute: typeof SubdomainAdminStaffRouteRoute
    }
    '/subdomain/admin/_staff/settings': {
      id: '/subdomain/admin/_staff/settings'
      path: '/settings'
      fullPath: '/subdomain/admin/settings'
      preLoaderRoute: typeof SubdomainAdminStaffSettingsRouteRouteImport
      parentRoute: typeof SubdomainAdminStaffRouteRoute
    }
    '/subdomain/app/_auth/forgot-password': {
      id: '/subdomain/app/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/subdomain/app/forgot-password'
      preLoaderRoute: typeof SubdomainAppAuthForgotPasswordRouteImport
      parentRoute: typeof SubdomainAppAuthRouteRoute
    }
    '/subdomain/app/_auth/two-factor': {
      id: '/subdomain/app/_auth/two-factor'
      path: '/two-factor'
      fullPath: '/subdomain/app/two-factor'
      preLoaderRoute: typeof SubdomainAppAuthTwoFactorRouteImport
      parentRoute: typeof SubdomainAppAuthRouteRoute
    }
    '/subdomain/app/_auth/verify-email': {
      id: '/subdomain/app/_auth/verify-email'
      path: '/verify-email'
      fullPath: '/subdomain/app/verify-email'
      preLoaderRoute: typeof SubdomainAppAuthVerifyEmailRouteImport
      parentRoute: typeof SubdomainAppAuthRouteRoute
    }
    '/subdomain/app/_auth/welcome': {
      id: '/subdomain/app/_auth/welcome'
      path: '/welcome'
      fullPath: '/subdomain/app/welcome'
      preLoaderRoute: typeof SubdomainAppAuthWelcomeRouteImport
      parentRoute: typeof SubdomainAppAuthRouteRoute
    }
    '/subdomain/app/_client/': {
      id: '/subdomain/app/_client/'
      path: '/'
      fullPath: '/subdomain/app/'
      preLoaderRoute: typeof SubdomainAppClientIndexRouteImport
      parentRoute: typeof SubdomainAppClientRouteRoute
    }
    '/subdomain/app/_client/settings': {
      id: '/subdomain/app/_client/settings'
      path: '/settings'
      fullPath: '/subdomain/app/settings'
      preLoaderRoute: typeof SubdomainAppClientSettingsRouteRouteImport
      parentRoute: typeof SubdomainAppClientRouteRoute
    }
    '/subdomain/admin/_staff/businesses/': {
      id: '/subdomain/admin/_staff/businesses/'
      path: '/businesses'
      fullPath: '/subdomain/admin/businesses/'
      preLoaderRoute: typeof SubdomainAdminStaffBusinessesIndexRouteImport
      parentRoute: typeof SubdomainAdminStaffRouteRoute
    }
    '/subdomain/admin/_staff/settings/': {
      id: '/subdomain/admin/_staff/settings/'
      path: '/'
      fullPath: '/subdomain/admin/settings/'
      preLoaderRoute: typeof SubdomainAdminStaffSettingsIndexRouteImport
      parentRoute: typeof SubdomainAdminStaffSettingsRouteRoute
    }
    '/subdomain/admin/_staff/settings/availability': {
      id: '/subdomain/admin/_staff/settings/availability'
      path: '/availability'
      fullPath: '/subdomain/admin/settings/availability'
      preLoaderRoute: typeof SubdomainAdminStaffSettingsAvailabilityRouteImport
      parentRoute: typeof SubdomainAdminStaffSettingsRouteRoute
    }
    '/subdomain/admin/_staff/settings/connections': {
      id: '/subdomain/admin/_staff/settings/connections'
      path: '/connections'
      fullPath: '/subdomain/admin/settings/connections'
      preLoaderRoute: typeof SubdomainAdminStaffSettingsConnectionsRouteImport
      parentRoute: typeof SubdomainAdminStaffSettingsRouteRoute
    }
    '/subdomain/admin/_staff/settings/notifications': {
      id: '/subdomain/admin/_staff/settings/notifications'
      path: '/notifications'
      fullPath: '/subdomain/admin/settings/notifications'
      preLoaderRoute: typeof SubdomainAdminStaffSettingsNotificationsRouteImport
      parentRoute: typeof SubdomainAdminStaffSettingsRouteRoute
    }
    '/subdomain/admin/_staff/settings/profile': {
      id: '/subdomain/admin/_staff/settings/profile'
      path: '/profile'
      fullPath: '/subdomain/admin/settings/profile'
      preLoaderRoute: typeof SubdomainAdminStaffSettingsProfileRouteImport
      parentRoute: typeof SubdomainAdminStaffSettingsRouteRoute
    }
    '/subdomain/admin/_staff/settings/security': {
      id: '/subdomain/admin/_staff/settings/security'
      path: '/security'
      fullPath: '/subdomain/admin/settings/security'
      preLoaderRoute: typeof SubdomainAdminStaffSettingsSecurityRouteImport
      parentRoute: typeof SubdomainAdminStaffSettingsRouteRoute
    }
    '/subdomain/admin/_staff/settings/workspace': {
      id: '/subdomain/admin/_staff/settings/workspace'
      path: '/workspace'
      fullPath: '/subdomain/admin/settings/workspace'
      preLoaderRoute: typeof SubdomainAdminStaffSettingsWorkspaceRouteRouteImport
      parentRoute: typeof SubdomainAdminStaffSettingsRouteRoute
    }
    '/subdomain/admin/_staff/staff/': {
      id: '/subdomain/admin/_staff/staff/'
      path: '/staff'
      fullPath: '/subdomain/admin/staff/'
      preLoaderRoute: typeof SubdomainAdminStaffStaffIndexRouteImport
      parentRoute: typeof SubdomainAdminStaffRouteRoute
    }
    '/subdomain/admin/_staff/staff/$staffId': {
      id: '/subdomain/admin/_staff/staff/$staffId'
      path: '/staff/$staffId'
      fullPath: '/subdomain/admin/staff/$staffId'
      preLoaderRoute: typeof SubdomainAdminStaffStaffStaffIdRouteImport
      parentRoute: typeof SubdomainAdminStaffRouteRoute
    }
    '/subdomain/app/_auth/onboarding/business': {
      id: '/subdomain/app/_auth/onboarding/business'
      path: '/onboarding/business'
      fullPath: '/subdomain/app/onboarding/business'
      preLoaderRoute: typeof SubdomainAppAuthOnboardingBusinessRouteImport
      parentRoute: typeof SubdomainAppAuthRouteRoute
    }
    '/subdomain/app/_auth/onboarding/industry': {
      id: '/subdomain/app/_auth/onboarding/industry'
      path: '/onboarding/industry'
      fullPath: '/subdomain/app/onboarding/industry'
      preLoaderRoute: typeof SubdomainAppAuthOnboardingIndustryRouteImport
      parentRoute: typeof SubdomainAppAuthRouteRoute
    }
    '/subdomain/app/_auth/onboarding/phone': {
      id: '/subdomain/app/_auth/onboarding/phone'
      path: '/onboarding/phone'
      fullPath: '/subdomain/app/onboarding/phone'
      preLoaderRoute: typeof SubdomainAppAuthOnboardingPhoneRouteImport
      parentRoute: typeof SubdomainAppAuthRouteRoute
    }
    '/subdomain/app/_auth/onboarding/socials': {
      id: '/subdomain/app/_auth/onboarding/socials'
      path: '/onboarding/socials'
      fullPath: '/subdomain/app/onboarding/socials'
      preLoaderRoute: typeof SubdomainAppAuthOnboardingSocialsRouteImport
      parentRoute: typeof SubdomainAppAuthRouteRoute
    }
    '/subdomain/app/_auth/onboarding/website': {
      id: '/subdomain/app/_auth/onboarding/website'
      path: '/onboarding/website'
      fullPath: '/subdomain/app/onboarding/website'
      preLoaderRoute: typeof SubdomainAppAuthOnboardingWebsiteRouteImport
      parentRoute: typeof SubdomainAppAuthRouteRoute
    }
    '/subdomain/app/_auth/sign-in/': {
      id: '/subdomain/app/_auth/sign-in/'
      path: '/sign-in'
      fullPath: '/subdomain/app/sign-in/'
      preLoaderRoute: typeof SubdomainAppAuthSignInIndexRouteImport
      parentRoute: typeof SubdomainAppAuthRouteRoute
    }
    '/subdomain/app/_auth/sign-in/email': {
      id: '/subdomain/app/_auth/sign-in/email'
      path: '/sign-in/email'
      fullPath: '/subdomain/app/sign-in/email'
      preLoaderRoute: typeof SubdomainAppAuthSignInEmailRouteImport
      parentRoute: typeof SubdomainAppAuthRouteRoute
    }
    '/subdomain/app/_auth/sign-up/': {
      id: '/subdomain/app/_auth/sign-up/'
      path: '/sign-up'
      fullPath: '/subdomain/app/sign-up/'
      preLoaderRoute: typeof SubdomainAppAuthSignUpIndexRouteImport
      parentRoute: typeof SubdomainAppAuthRouteRoute
    }
    '/subdomain/app/_auth/sign-up/email': {
      id: '/subdomain/app/_auth/sign-up/email'
      path: '/sign-up/email'
      fullPath: '/subdomain/app/sign-up/email'
      preLoaderRoute: typeof SubdomainAppAuthSignUpEmailRouteImport
      parentRoute: typeof SubdomainAppAuthRouteRoute
    }
    '/subdomain/app/_client/projects/': {
      id: '/subdomain/app/_client/projects/'
      path: '/projects'
      fullPath: '/subdomain/app/projects/'
      preLoaderRoute: typeof SubdomainAppClientProjectsIndexRouteImport
      parentRoute: typeof SubdomainAppClientRouteRoute
    }
    '/subdomain/app/_client/projects/$projectId': {
      id: '/subdomain/app/_client/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/subdomain/app/projects/$projectId'
      preLoaderRoute: typeof SubdomainAppClientProjectsProjectIdRouteImport
      parentRoute: typeof SubdomainAppClientRouteRoute
    }
    '/subdomain/app/_client/projects/deliverables': {
      id: '/subdomain/app/_client/projects/deliverables'
      path: '/projects/deliverables'
      fullPath: '/subdomain/app/projects/deliverables'
      preLoaderRoute: typeof SubdomainAppClientProjectsDeliverablesRouteImport
      parentRoute: typeof SubdomainAppClientRouteRoute
    }
    '/subdomain/app/_client/settings/notifications': {
      id: '/subdomain/app/_client/settings/notifications'
      path: '/notifications'
      fullPath: '/subdomain/app/settings/notifications'
      preLoaderRoute: typeof SubdomainAppClientSettingsNotificationsRouteImport
      parentRoute: typeof SubdomainAppClientSettingsRouteRoute
    }
    '/subdomain/app/_client/settings/profile': {
      id: '/subdomain/app/_client/settings/profile'
      path: '/profile'
      fullPath: '/subdomain/app/settings/profile'
      preLoaderRoute: typeof SubdomainAppClientSettingsProfileRouteImport
      parentRoute: typeof SubdomainAppClientSettingsRouteRoute
    }
    '/subdomain/app/_client/settings/security': {
      id: '/subdomain/app/_client/settings/security'
      path: '/security'
      fullPath: '/subdomain/app/settings/security'
      preLoaderRoute: typeof SubdomainAppClientSettingsSecurityRouteImport
      parentRoute: typeof SubdomainAppClientSettingsRouteRoute
    }
    '/subdomain/app/_client/tasks/$taskId': {
      id: '/subdomain/app/_client/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/subdomain/app/tasks/$taskId'
      preLoaderRoute: typeof SubdomainAppClientTasksTaskIdRouteImport
      parentRoute: typeof SubdomainAppClientRouteRoute
    }
    '/subdomain/admin/_staff/businesses/$businessId/': {
      id: '/subdomain/admin/_staff/businesses/$businessId/'
      path: '/businesses/$businessId'
      fullPath: '/subdomain/admin/businesses/$businessId/'
      preLoaderRoute: typeof SubdomainAdminStaffBusinessesBusinessIdIndexRouteImport
      parentRoute: typeof SubdomainAdminStaffRouteRoute
    }
    '/subdomain/admin/_staff/businesses/$businessId/deliverables': {
      id: '/subdomain/admin/_staff/businesses/$businessId/deliverables'
      path: '/businesses/$businessId/deliverables'
      fullPath: '/subdomain/admin/businesses/$businessId/deliverables'
      preLoaderRoute: typeof SubdomainAdminStaffBusinessesBusinessIdDeliverablesRouteImport
      parentRoute: typeof SubdomainAdminStaffRouteRoute
    }
    '/subdomain/admin/_staff/businesses/$businessId/projects': {
      id: '/subdomain/admin/_staff/businesses/$businessId/projects'
      path: '/businesses/$businessId/projects'
      fullPath: '/subdomain/admin/businesses/$businessId/projects'
      preLoaderRoute: typeof SubdomainAdminStaffBusinessesBusinessIdProjectsRouteImport
      parentRoute: typeof SubdomainAdminStaffRouteRoute
    }
    '/subdomain/admin/_staff/projects/$projectId/': {
      id: '/subdomain/admin/_staff/projects/$projectId/'
      path: '/projects/$projectId'
      fullPath: '/subdomain/admin/projects/$projectId/'
      preLoaderRoute: typeof SubdomainAdminStaffProjectsProjectIdIndexRouteImport
      parentRoute: typeof SubdomainAdminStaffRouteRoute
    }
    '/subdomain/admin/_staff/settings/workspace/agency': {
      id: '/subdomain/admin/_staff/settings/workspace/agency'
      path: '/agency'
      fullPath: '/subdomain/admin/settings/workspace/agency'
      preLoaderRoute: typeof SubdomainAdminStaffSettingsWorkspaceAgencyRouteImport
      parentRoute: typeof SubdomainAdminStaffSettingsWorkspaceRouteRoute
    }
    '/subdomain/admin/_staff/settings/workspace/flags': {
      id: '/subdomain/admin/_staff/settings/workspace/flags'
      path: '/flags'
      fullPath: '/subdomain/admin/settings/workspace/flags'
      preLoaderRoute: typeof SubdomainAdminStaffSettingsWorkspaceFlagsRouteImport
      parentRoute: typeof SubdomainAdminStaffSettingsWorkspaceRouteRoute
    }
    '/subdomain/admin/_staff/settings/workspace/integrations': {
      id: '/subdomain/admin/_staff/settings/workspace/integrations'
      path: '/integrations'
      fullPath: '/subdomain/admin/settings/workspace/integrations'
      preLoaderRoute: typeof SubdomainAdminStaffSettingsWorkspaceIntegrationsRouteImport
      parentRoute: typeof SubdomainAdminStaffSettingsWorkspaceRouteRoute
    }
    '/subdomain/admin/_staff/settings/workspace/limits': {
      id: '/subdomain/admin/_staff/settings/workspace/limits'
      path: '/limits'
      fullPath: '/subdomain/admin/settings/workspace/limits'
      preLoaderRoute: typeof SubdomainAdminStaffSettingsWorkspaceLimitsRouteImport
      parentRoute: typeof SubdomainAdminStaffSettingsWorkspaceRouteRoute
    }
    '/subdomain/admin/_staff/settings/workspace/maintenance': {
      id: '/subdomain/admin/_staff/settings/workspace/maintenance'
      path: '/maintenance'
      fullPath: '/subdomain/admin/settings/workspace/maintenance'
      preLoaderRoute: typeof SubdomainAdminStaffSettingsWorkspaceMaintenanceRouteImport
      parentRoute: typeof SubdomainAdminStaffSettingsWorkspaceRouteRoute
    }
    '/subdomain/admin/_staff/settings/workspace/roles': {
      id: '/subdomain/admin/_staff/settings/workspace/roles'
      path: '/roles'
      fullPath: '/subdomain/admin/settings/workspace/roles'
      preLoaderRoute: typeof SubdomainAdminStaffSettingsWorkspaceRolesRouteImport
      parentRoute: typeof SubdomainAdminStaffSettingsWorkspaceRouteRoute
    }
    '/subdomain/admin/_staff/settings/workspace/scheduling': {
      id: '/subdomain/admin/_staff/settings/workspace/scheduling'
      path: '/scheduling'
      fullPath: '/subdomain/admin/settings/workspace/scheduling'
      preLoaderRoute: typeof SubdomainAdminStaffSettingsWorkspaceSchedulingRouteImport
      parentRoute: typeof SubdomainAdminStaffSettingsWorkspaceRouteRoute
    }
    '/subdomain/admin/_staff/settings/workspace/security-policy': {
      id: '/subdomain/admin/_staff/settings/workspace/security-policy'
      path: '/security-policy'
      fullPath: '/subdomain/admin/settings/workspace/security-policy'
      preLoaderRoute: typeof SubdomainAdminStaffSettingsWorkspaceSecurityPolicyRouteImport
      parentRoute: typeof SubdomainAdminStaffSettingsWorkspaceRouteRoute
    }
    '/subdomain/admin/_staff/settings/workspace/staff-security': {
      id: '/subdomain/admin/_staff/settings/workspace/staff-security'
      path: '/staff-security'
      fullPath: '/subdomain/admin/settings/workspace/staff-security'
      preLoaderRoute: typeof SubdomainAdminStaffSettingsWorkspaceStaffSecurityRouteImport
      parentRoute: typeof SubdomainAdminStaffSettingsWorkspaceRouteRoute
    }
    '/subdomain/admin/_staff/settings/workspace/team-notifications': {
      id: '/subdomain/admin/_staff/settings/workspace/team-notifications'
      path: '/team-notifications'
      fullPath: '/subdomain/admin/settings/workspace/team-notifications'
      preLoaderRoute: typeof SubdomainAdminStaffSettingsWorkspaceTeamNotificationsRouteImport
      parentRoute: typeof SubdomainAdminStaffSettingsWorkspaceRouteRoute
    }
    '/subdomain/admin/_staff/tasks/$taskId/': {
      id: '/subdomain/admin/_staff/tasks/$taskId/'
      path: '/tasks/$taskId'
      fullPath: '/subdomain/admin/tasks/$taskId/'
      preLoaderRoute: typeof SubdomainAdminStaffTasksTaskIdIndexRouteImport
      parentRoute: typeof SubdomainAdminStaffRouteRoute
    }
    '/subdomain/admin/_staff/tasks/$taskId/edit': {
      id: '/subdomain/admin/_staff/tasks/$taskId/edit'
      path: '/tasks/$taskId/edit'
      fullPath: '/subdomain/admin/tasks/$taskId/edit'
      preLoaderRoute: typeof SubdomainAdminStaffTasksTaskIdEditRouteImport
      parentRoute: typeof SubdomainAdminStaffRouteRoute
    }
    '/subdomain/admin/_staff/tasks/$taskId/submit': {
      id: '/subdomain/admin/_staff/tasks/$taskId/submit'
      path: '/tasks/$taskId/submit'
      fullPath: '/subdomain/admin/tasks/$taskId/submit'
      preLoaderRoute: typeof SubdomainAdminStaffTasksTaskIdSubmitRouteImport
      parentRoute: typeof SubdomainAdminStaffRouteRoute
    }
    '/subdomain/admin/_staff/workbench/reviews/': {
      id: '/subdomain/admin/_staff/workbench/reviews/'
      path: '/workbench/reviews'
      fullPath: '/subdomain/admin/workbench/reviews/'
      preLoaderRoute: typeof SubdomainAdminStaffWorkbenchReviewsIndexRouteImport
      parentRoute: typeof SubdomainAdminStaffRouteRoute
    }
    '/subdomain/admin/_staff/workbench/reviews/$taskId': {
      id: '/subdomain/admin/_staff/workbench/reviews/$taskId'
      path: '/workbench/reviews/$taskId'
      fullPath: '/subdomain/admin/workbench/reviews/$taskId'
      preLoaderRoute: typeof SubdomainAdminStaffWorkbenchReviewsTaskIdRouteImport
      parentRoute: typeof SubdomainAdminStaffRouteRoute
    }
    '/subdomain/app/_client/work/review/$taskId': {
      id: '/subdomain/app/_client/work/review/$taskId'
      path: '/work/review/$taskId'
      fullPath: '/subdomain/app/work/review/$taskId'
      preLoaderRoute: typeof SubdomainAppClientWorkReviewTaskIdRouteImport
      parentRoute: typeof SubdomainAppClientRouteRoute
    }
    '/subdomain/admin/_staff/projects/$projectId/tasks/new': {
      id: '/subdomain/admin/_staff/projects/$projectId/tasks/new'
      path: '/projects/$projectId/tasks/new'
      fullPath: '/subdomain/admin/projects/$projectId/tasks/new'
      preLoaderRoute: typeof SubdomainAdminStaffProjectsProjectIdTasksNewRouteImport
      parentRoute: typeof SubdomainAdminStaffRouteRoute
    }
  }
}

interface SubdomainAdminAuthRouteRouteChildren {
  SubdomainAdminAuthAdminLoginRoute: typeof SubdomainAdminAuthAdminLoginRoute
  SubdomainAdminAuthForgotPasswordRoute: typeof SubdomainAdminAuthForgotPasswordRoute
  SubdomainAdminAuthInviteRoute: typeof SubdomainAdminAuthInviteRoute
  SubdomainAdminAuthTwoFactorRoute: typeof SubdomainAdminAuthTwoFactorRoute
}

const SubdomainAdminAuthRouteRouteChildren: SubdomainAdminAuthRouteRouteChildren =
  {
    SubdomainAdminAuthAdminLoginRoute: SubdomainAdminAuthAdminLoginRoute,
    SubdomainAdminAuthForgotPasswordRoute:
      SubdomainAdminAuthForgotPasswordRoute,
    SubdomainAdminAuthInviteRoute: SubdomainAdminAuthInviteRoute,
    SubdomainAdminAuthTwoFactorRoute: SubdomainAdminAuthTwoFactorRoute,
  }

const SubdomainAdminAuthRouteRouteWithChildren =
  SubdomainAdminAuthRouteRoute._addFileChildren(
    SubdomainAdminAuthRouteRouteChildren,
  )

interface SubdomainAdminStaffSettingsWorkspaceRouteRouteChildren {
  SubdomainAdminStaffSettingsWorkspaceAgencyRoute: typeof SubdomainAdminStaffSettingsWorkspaceAgencyRoute
  SubdomainAdminStaffSettingsWorkspaceFlagsRoute: typeof SubdomainAdminStaffSettingsWorkspaceFlagsRoute
  SubdomainAdminStaffSettingsWorkspaceIntegrationsRoute: typeof SubdomainAdminStaffSettingsWorkspaceIntegrationsRoute
  SubdomainAdminStaffSettingsWorkspaceLimitsRoute: typeof SubdomainAdminStaffSettingsWorkspaceLimitsRoute
  SubdomainAdminStaffSettingsWorkspaceMaintenanceRoute: typeof SubdomainAdminStaffSettingsWorkspaceMaintenanceRoute
  SubdomainAdminStaffSettingsWorkspaceRolesRoute: typeof SubdomainAdminStaffSettingsWorkspaceRolesRoute
  SubdomainAdminStaffSettingsWorkspaceSchedulingRoute: typeof SubdomainAdminStaffSettingsWorkspaceSchedulingRoute
  SubdomainAdminStaffSettingsWorkspaceSecurityPolicyRoute: typeof SubdomainAdminStaffSettingsWorkspaceSecurityPolicyRoute
  SubdomainAdminStaffSettingsWorkspaceStaffSecurityRoute: typeof SubdomainAdminStaffSettingsWorkspaceStaffSecurityRoute
  SubdomainAdminStaffSettingsWorkspaceTeamNotificationsRoute: typeof SubdomainAdminStaffSettingsWorkspaceTeamNotificationsRoute
}

const SubdomainAdminStaffSettingsWorkspaceRouteRouteChildren: SubdomainAdminStaffSettingsWorkspaceRouteRouteChildren =
  {
    SubdomainAdminStaffSettingsWorkspaceAgencyRoute:
      SubdomainAdminStaffSettingsWorkspaceAgencyRoute,
    SubdomainAdminStaffSettingsWorkspaceFlagsRoute:
      SubdomainAdminStaffSettingsWorkspaceFlagsRoute,
    SubdomainAdminStaffSettingsWorkspaceIntegrationsRoute:
      SubdomainAdminStaffSettingsWorkspaceIntegrationsRoute,
    SubdomainAdminStaffSettingsWorkspaceLimitsRoute:
      SubdomainAdminStaffSettingsWorkspaceLimitsRoute,
    SubdomainAdminStaffSettingsWorkspaceMaintenanceRoute:
      SubdomainAdminStaffSettingsWorkspaceMaintenanceRoute,
    SubdomainAdminStaffSettingsWorkspaceRolesRoute:
      SubdomainAdminStaffSettingsWorkspaceRolesRoute,
    SubdomainAdminStaffSettingsWorkspaceSchedulingRoute:
      SubdomainAdminStaffSettingsWorkspaceSchedulingRoute,
    SubdomainAdminStaffSettingsWorkspaceSecurityPolicyRoute:
      SubdomainAdminStaffSettingsWorkspaceSecurityPolicyRoute,
    SubdomainAdminStaffSettingsWorkspaceStaffSecurityRoute:
      SubdomainAdminStaffSettingsWorkspaceStaffSecurityRoute,
    SubdomainAdminStaffSettingsWorkspaceTeamNotificationsRoute:
      SubdomainAdminStaffSettingsWorkspaceTeamNotificationsRoute,
  }

const SubdomainAdminStaffSettingsWorkspaceRouteRouteWithChildren =
  SubdomainAdminStaffSettingsWorkspaceRouteRoute._addFileChildren(
    SubdomainAdminStaffSettingsWorkspaceRouteRouteChildren,
  )

interface SubdomainAdminStaffSettingsRouteRouteChildren {
  SubdomainAdminStaffSettingsWorkspaceRouteRoute: typeof SubdomainAdminStaffSettingsWorkspaceRouteRouteWithChildren
  SubdomainAdminStaffSettingsAvailabilityRoute: typeof SubdomainAdminStaffSettingsAvailabilityRoute
  SubdomainAdminStaffSettingsConnectionsRoute: typeof SubdomainAdminStaffSettingsConnectionsRoute
  SubdomainAdminStaffSettingsNotificationsRoute: typeof SubdomainAdminStaffSettingsNotificationsRoute
  SubdomainAdminStaffSettingsProfileRoute: typeof SubdomainAdminStaffSettingsProfileRoute
  SubdomainAdminStaffSettingsSecurityRoute: typeof SubdomainAdminStaffSettingsSecurityRoute
  SubdomainAdminStaffSettingsIndexRoute: typeof SubdomainAdminStaffSettingsIndexRoute
}

const SubdomainAdminStaffSettingsRouteRouteChildren: SubdomainAdminStaffSettingsRouteRouteChildren =
  {
    SubdomainAdminStaffSettingsWorkspaceRouteRoute:
      SubdomainAdminStaffSettingsWorkspaceRouteRouteWithChildren,
    SubdomainAdminStaffSettingsAvailabilityRoute:
      SubdomainAdminStaffSettingsAvailabilityRoute,
    SubdomainAdminStaffSettingsConnectionsRoute:
      SubdomainAdminStaffSettingsConnectionsRoute,
    SubdomainAdminStaffSettingsNotificationsRoute:
      SubdomainAdminStaffSettingsNotificationsRoute,
    SubdomainAdminStaffSettingsProfileRoute:
      SubdomainAdminStaffSettingsProfileRoute,
    SubdomainAdminStaffSettingsSecurityRoute:
      SubdomainAdminStaffSettingsSecurityRoute,
    SubdomainAdminStaffSettingsIndexRoute:
      SubdomainAdminStaffSettingsIndexRoute,
  }

const SubdomainAdminStaffSettingsRouteRouteWithChildren =
  SubdomainAdminStaffSettingsRouteRoute._addFileChildren(
    SubdomainAdminStaffSettingsRouteRouteChildren,
  )

interface SubdomainAdminStaffRouteRouteChildren {
  SubdomainAdminStaffSettingsRouteRoute: typeof SubdomainAdminStaffSettingsRouteRouteWithChildren
  SubdomainAdminStaffIndexRoute: typeof SubdomainAdminStaffIndexRoute
  SubdomainAdminStaffStaffStaffIdRoute: typeof SubdomainAdminStaffStaffStaffIdRoute
  SubdomainAdminStaffBusinessesIndexRoute: typeof SubdomainAdminStaffBusinessesIndexRoute
  SubdomainAdminStaffStaffIndexRoute: typeof SubdomainAdminStaffStaffIndexRoute
  SubdomainAdminStaffBusinessesBusinessIdDeliverablesRoute: typeof SubdomainAdminStaffBusinessesBusinessIdDeliverablesRoute
  SubdomainAdminStaffBusinessesBusinessIdProjectsRoute: typeof SubdomainAdminStaffBusinessesBusinessIdProjectsRoute
  SubdomainAdminStaffTasksTaskIdEditRoute: typeof SubdomainAdminStaffTasksTaskIdEditRoute
  SubdomainAdminStaffTasksTaskIdSubmitRoute: typeof SubdomainAdminStaffTasksTaskIdSubmitRoute
  SubdomainAdminStaffWorkbenchReviewsTaskIdRoute: typeof SubdomainAdminStaffWorkbenchReviewsTaskIdRoute
  SubdomainAdminStaffBusinessesBusinessIdIndexRoute: typeof SubdomainAdminStaffBusinessesBusinessIdIndexRoute
  SubdomainAdminStaffProjectsProjectIdIndexRoute: typeof SubdomainAdminStaffProjectsProjectIdIndexRoute
  SubdomainAdminStaffTasksTaskIdIndexRoute: typeof SubdomainAdminStaffTasksTaskIdIndexRoute
  SubdomainAdminStaffWorkbenchReviewsIndexRoute: typeof SubdomainAdminStaffWorkbenchReviewsIndexRoute
  SubdomainAdminStaffProjectsProjectIdTasksNewRoute: typeof SubdomainAdminStaffProjectsProjectIdTasksNewRoute
}

const SubdomainAdminStaffRouteRouteChildren: SubdomainAdminStaffRouteRouteChildren =
  {
    SubdomainAdminStaffSettingsRouteRoute:
      SubdomainAdminStaffSettingsRouteRouteWithChildren,
    SubdomainAdminStaffIndexRoute: SubdomainAdminStaffIndexRoute,
    SubdomainAdminStaffStaffStaffIdRoute: SubdomainAdminStaffStaffStaffIdRoute,
    SubdomainAdminStaffBusinessesIndexRoute:
      SubdomainAdminStaffBusinessesIndexRoute,
    SubdomainAdminStaffStaffIndexRoute: SubdomainAdminStaffStaffIndexRoute,
    SubdomainAdminStaffBusinessesBusinessIdDeliverablesRoute:
      SubdomainAdminStaffBusinessesBusinessIdDeliverablesRoute,
    SubdomainAdminStaffBusinessesBusinessIdProjectsRoute:
      SubdomainAdminStaffBusinessesBusinessIdProjectsRoute,
    SubdomainAdminStaffTasksTaskIdEditRoute:
      SubdomainAdminStaffTasksTaskIdEditRoute,
    SubdomainAdminStaffTasksTaskIdSubmitRoute:
      SubdomainAdminStaffTasksTaskIdSubmitRoute,
    SubdomainAdminStaffWorkbenchReviewsTaskIdRoute:
      SubdomainAdminStaffWorkbenchReviewsTaskIdRoute,
    SubdomainAdminStaffBusinessesBusinessIdIndexRoute:
      SubdomainAdminStaffBusinessesBusinessIdIndexRoute,
    SubdomainAdminStaffProjectsProjectIdIndexRoute:
      SubdomainAdminStaffProjectsProjectIdIndexRoute,
    SubdomainAdminStaffTasksTaskIdIndexRoute:
      SubdomainAdminStaffTasksTaskIdIndexRoute,
    SubdomainAdminStaffWorkbenchReviewsIndexRoute:
      SubdomainAdminStaffWorkbenchReviewsIndexRoute,
    SubdomainAdminStaffProjectsProjectIdTasksNewRoute:
      SubdomainAdminStaffProjectsProjectIdTasksNewRoute,
  }

const SubdomainAdminStaffRouteRouteWithChildren =
  SubdomainAdminStaffRouteRoute._addFileChildren(
    SubdomainAdminStaffRouteRouteChildren,
  )

interface SubdomainAdminRouteRouteChildren {
  SubdomainAdminAuthRouteRoute: typeof SubdomainAdminAuthRouteRouteWithChildren
  SubdomainAdminStaffRouteRoute: typeof SubdomainAdminStaffRouteRouteWithChildren
}

const SubdomainAdminRouteRouteChildren: SubdomainAdminRouteRouteChildren = {
  SubdomainAdminAuthRouteRoute: SubdomainAdminAuthRouteRouteWithChildren,
  SubdomainAdminStaffRouteRoute: SubdomainAdminStaffRouteRouteWithChildren,
}

const SubdomainAdminRouteRouteWithChildren =
  SubdomainAdminRouteRoute._addFileChildren(SubdomainAdminRouteRouteChildren)

interface SubdomainAppAuthRouteRouteChildren {
  SubdomainAppAuthForgotPasswordRoute: typeof SubdomainAppAuthForgotPasswordRoute
  SubdomainAppAuthTwoFactorRoute: typeof SubdomainAppAuthTwoFactorRoute
  SubdomainAppAuthVerifyEmailRoute: typeof SubdomainAppAuthVerifyEmailRoute
  SubdomainAppAuthWelcomeRoute: typeof SubdomainAppAuthWelcomeRoute
  SubdomainAppAuthOnboardingBusinessRoute: typeof SubdomainAppAuthOnboardingBusinessRoute
  SubdomainAppAuthOnboardingIndustryRoute: typeof SubdomainAppAuthOnboardingIndustryRoute
  SubdomainAppAuthOnboardingPhoneRoute: typeof SubdomainAppAuthOnboardingPhoneRoute
  SubdomainAppAuthOnboardingSocialsRoute: typeof SubdomainAppAuthOnboardingSocialsRoute
  SubdomainAppAuthOnboardingWebsiteRoute: typeof SubdomainAppAuthOnboardingWebsiteRoute
  SubdomainAppAuthSignInEmailRoute: typeof SubdomainAppAuthSignInEmailRoute
  SubdomainAppAuthSignUpEmailRoute: typeof SubdomainAppAuthSignUpEmailRoute
  SubdomainAppAuthSignInIndexRoute: typeof SubdomainAppAuthSignInIndexRoute
  SubdomainAppAuthSignUpIndexRoute: typeof SubdomainAppAuthSignUpIndexRoute
}

const SubdomainAppAuthRouteRouteChildren: SubdomainAppAuthRouteRouteChildren = {
  SubdomainAppAuthForgotPasswordRoute: SubdomainAppAuthForgotPasswordRoute,
  SubdomainAppAuthTwoFactorRoute: SubdomainAppAuthTwoFactorRoute,
  SubdomainAppAuthVerifyEmailRoute: SubdomainAppAuthVerifyEmailRoute,
  SubdomainAppAuthWelcomeRoute: SubdomainAppAuthWelcomeRoute,
  SubdomainAppAuthOnboardingBusinessRoute:
    SubdomainAppAuthOnboardingBusinessRoute,
  SubdomainAppAuthOnboardingIndustryRoute:
    SubdomainAppAuthOnboardingIndustryRoute,
  SubdomainAppAuthOnboardingPhoneRoute: SubdomainAppAuthOnboardingPhoneRoute,
  SubdomainAppAuthOnboardingSocialsRoute:
    SubdomainAppAuthOnboardingSocialsRoute,
  SubdomainAppAuthOnboardingWebsiteRoute:
    SubdomainAppAuthOnboardingWebsiteRoute,
  SubdomainAppAuthSignInEmailRoute: SubdomainAppAuthSignInEmailRoute,
  SubdomainAppAuthSignUpEmailRoute: SubdomainAppAuthSignUpEmailRoute,
  SubdomainAppAuthSignInIndexRoute: SubdomainAppAuthSignInIndexRoute,
  SubdomainAppAuthSignUpIndexRoute: SubdomainAppAuthSignUpIndexRoute,
}

const SubdomainAppAuthRouteRouteWithChildren =
  SubdomainAppAuthRouteRoute._addFileChildren(
    SubdomainAppAuthRouteRouteChildren,
  )

interface SubdomainAppClientSettingsRouteRouteChildren {
  SubdomainAppClientSettingsNotificationsRoute: typeof SubdomainAppClientSettingsNotificationsRoute
  SubdomainAppClientSettingsProfileRoute: typeof SubdomainAppClientSettingsProfileRoute
  SubdomainAppClientSettingsSecurityRoute: typeof SubdomainAppClientSettingsSecurityRoute
}

const SubdomainAppClientSettingsRouteRouteChildren: SubdomainAppClientSettingsRouteRouteChildren =
  {
    SubdomainAppClientSettingsNotificationsRoute:
      SubdomainAppClientSettingsNotificationsRoute,
    SubdomainAppClientSettingsProfileRoute:
      SubdomainAppClientSettingsProfileRoute,
    SubdomainAppClientSettingsSecurityRoute:
      SubdomainAppClientSettingsSecurityRoute,
  }

const SubdomainAppClientSettingsRouteRouteWithChildren =
  SubdomainAppClientSettingsRouteRoute._addFileChildren(
    SubdomainAppClientSettingsRouteRouteChildren,
  )

interface SubdomainAppClientRouteRouteChildren {
  SubdomainAppClientSettingsRouteRoute: typeof SubdomainAppClientSettingsRouteRouteWithChildren
  SubdomainAppClientIndexRoute: typeof SubdomainAppClientIndexRoute
  SubdomainAppClientProjectsProjectIdRoute: typeof SubdomainAppClientProjectsProjectIdRoute
  SubdomainAppClientProjectsDeliverablesRoute: typeof SubdomainAppClientProjectsDeliverablesRoute
  SubdomainAppClientTasksTaskIdRoute: typeof SubdomainAppClientTasksTaskIdRoute
  SubdomainAppClientProjectsIndexRoute: typeof SubdomainAppClientProjectsIndexRoute
  SubdomainAppClientWorkReviewTaskIdRoute: typeof SubdomainAppClientWorkReviewTaskIdRoute
}

const SubdomainAppClientRouteRouteChildren: SubdomainAppClientRouteRouteChildren =
  {
    SubdomainAppClientSettingsRouteRoute:
      SubdomainAppClientSettingsRouteRouteWithChildren,
    SubdomainAppClientIndexRoute: SubdomainAppClientIndexRoute,
    SubdomainAppClientProjectsProjectIdRoute:
      SubdomainAppClientProjectsProjectIdRoute,
    SubdomainAppClientProjectsDeliverablesRoute:
      SubdomainAppClientProjectsDeliverablesRoute,
    SubdomainAppClientTasksTaskIdRoute: SubdomainAppClientTasksTaskIdRoute,
    SubdomainAppClientProjectsIndexRoute: SubdomainAppClientProjectsIndexRoute,
    SubdomainAppClientWorkReviewTaskIdRoute:
      SubdomainAppClientWorkReviewTaskIdRoute,
  }

const SubdomainAppClientRouteRouteWithChildren =
  SubdomainAppClientRouteRoute._addFileChildren(
    SubdomainAppClientRouteRouteChildren,
  )

interface SubdomainAppRouteRouteChildren {
  SubdomainAppAuthRouteRoute: typeof SubdomainAppAuthRouteRouteWithChildren
  SubdomainAppClientRouteRoute: typeof SubdomainAppClientRouteRouteWithChildren
  SubdomainAppAuditRoute: typeof SubdomainAppAuditRoute
}

const SubdomainAppRouteRouteChildren: SubdomainAppRouteRouteChildren = {
  SubdomainAppAuthRouteRoute: SubdomainAppAuthRouteRouteWithChildren,
  SubdomainAppClientRouteRoute: SubdomainAppClientRouteRouteWithChildren,
  SubdomainAppAuditRoute: SubdomainAppAuditRoute,
}

const SubdomainAppRouteRouteWithChildren =
  SubdomainAppRouteRoute._addFileChildren(SubdomainAppRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SubdomainAdminRouteRoute: SubdomainAdminRouteRouteWithChildren,
  SubdomainAppRouteRoute: SubdomainAppRouteRouteWithChildren,
  SubdomainIndexRoute: SubdomainIndexRoute,
  SubdomainDevGraphRoute: SubdomainDevGraphRoute,
  SubdomainDevIndexRoute: SubdomainDevIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
